import React from "react";
import "./style.scss";
import BSTSeggregation from "../../../components/Seggregation/BST2Seggregation";
const BSTSeggregationPage = () => {
  return (
    <div className="bst_seggregation_wrapper">
      <BSTSeggregation />
    </div>
  );
};
export default BSTSeggregationPage;
